class RenderImageBox{

    constructor(file, res_size){

        res_size = res_size || 720;

        let self = this;

        this.file = file;

        let size = this.file.sizes.find(size => size.type === 'image_' + res_size);

        this.box = $('<div class="image_box load">' +
            '<i class="icon-cross"></i>' +
            '<img alt src="' + size.url +'"><input type="hidden" name="images[]" value="' + file.key + '">' +
        '</div>');

        this.cross = this.box.find('.icon-cross');
        this.cross.on('click', function(){
            self.onRemove();
        })

    }

    getBox(){
        return this.box;
    }

    onRemove(){
        this.box.trigger('onRemove', [this.file]);
        this.box.remove();
    }

}

export {RenderImageBox}